import { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { dialog } from "../components/Dialog";
import { useTranslation } from "react-i18next";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { t } = useTranslation();
  const user = useSelector((state) => state.root.user);
  const userProfile = useSelector((state) => state.root.userProfile);
  const loadingAuth = useSelector((state) => state.root.loadingAuth);

  const navigate = useNavigate();

  useEffect(() => {
    if (loadingAuth) return;
    if (!user) return;

    if (userProfile) {
      toast.success(t("general.auth.successToast"));
    } else {
      navigate("/auth/complete-profile", { state: { isVerified: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProfile, user, loadingAuth]);

  const triggerAuthCheck = () => {
    if (!user) {
      dialog.info({
        title: t("pages.auth.loginModal.title"),
        text: t("pages.auth.loginModal.text"),
        closeButton: false,
        buttons: [
          {
            text: t("pages.auth.loginModal.buttons.noThanks"),
            variant: "outlineSecondary",
            closeOnClick: true,
          },
          {
            text: t("pages.auth.loginModal.buttons.loginAndSave"),
            variant: "info",
            action: () => navigate("/auth/signin"),
            closeOnClick: true,
          },
        ],
      });
      return false;
    }
    return true;
  };

  return (
    <AuthContext.Provider
      value={{
        loadingAuth,
        triggerAuthCheck,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
